import { parse } from 'url'

import { normalizeUrl } from 'shared/utils/url'

const getProductUrl = (canonicalURL = '') => {
  const url =
    process.env.APP_ENV === 'production'
      ? canonicalURL
      : parse(canonicalURL).path

  return normalizeUrl(url)
}

export default getProductUrl
